import findPassword from "./index.vue";

(findPassword as any).install = function (Vue: any) {
  Vue.component(findPassword.name, findPassword);
};

export default findPassword;
